module.exports = __webpack_public_path__ + "img/eye-selected.37de254f.svg";